import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";

import usePageData from "@hooks/usePageData";

const UnboundPeriod = () => {
  const { unbounding_period } = usePageData("$.page.data")[0] || {};

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      fontSize={{ base: "12px", md: "14px" }}
      align="center"
      gap="0.5rem"
    >
      <Flex alignItems="center" gap="0.5rem">
        <Text>{unbounding_period.title}</Text>
        <Tooltip
          label={unbounding_period.tool_tip_text}
          color="textSecondary"
          fontSize="14px"
          bg="tooltipBackground"
          placement="top"
          hasArrow
          p="1rem"
          borderRadius="8px"
        >
          <span>
            <AiOutlineInfoCircle />
          </span>
        </Tooltip>
      </Flex>

      <Box>
        <Text fontWeight={{ base: "700", md: "600" }}>7 Days</Text>
      </Box>
    </Flex>
  );
};

export default UnboundPeriod;
